import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { Badge, Variant } from '@/Atomic/Atoms/Badge'
import { StringText } from '@/Atomic/Atoms/StringText'
import { DataClassName } from '@/Data/const'
import { AttributeType } from '@/Data/typesV2'
import { getVariantForGroup } from '@/utils/enumGroupVariant'
import { isString } from '@/utils/isString'
import './DisplayField.scss'

interface DisplayFieldProps {
  value?: string | string[]
  type?: AttributeType
  referenceDataItem?: DataItem
  variant?: Variant
  enumGroup?: string
}

export const DisplayField: React.FC<DisplayFieldProps> = ({
  type,
  value,
  referenceDataItem,
  variant = 'success',
  enumGroup,
}) => {
  const { t } = useTranslation()

  if (value === undefined || value === null) return

  if (type === 'boolean') {
    const displayValue = value === 'true' ? t('common.yes') : t('common.no')
    return <StringText value={displayValue} />
  }

  if (type === 'enum' || type === 'enumarray') {
    const resolvedVariant =
      enumGroup !== undefined ? getVariantForGroup(enumGroup) : variant
    return <Badge value={value} variant={resolvedVariant} />
  }

  if (!isString(value)) return

  if (type === 'reference') {
    const links: string[] = [
      DataClassName.ACTIVITY,
      DataClassName.COMPANY,
      DataClassName.PERSON,
    ]
    const isLink = links.includes(referenceDataItem?.dataClassName() ?? '')
    return (
      <StringText
        variant={isLink ? 'link' : 'default'}
        value={value}
        dataItem={isLink ? referenceDataItem : undefined}
      />
    )
  }

  return <StringText value={value} />
}
